module.exports = __webpack_public_path__ + "static/media/edit.8b00f14c.svg";